<template>
  <b-card :header="caption">
    <b-row>
      <b-col sm="2">
        <download-excel :data="[]" :fetch="fetchExportToCsv" :stringifyLongNum="true">
          <b-button block variant="primary">Export CSV</b-button>
        </download-excel>

      </b-col>
      <b-col sm="4" class="ml-auto">
        <b-form-group
            label="Search"
            label-for="searchTable"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="search" id="searchTable" type="text" placeholder="Search..."></b-form-input>
          </b-form-group>
      </b-col>
    </b-row>
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="filteredItems" :fields="fields" :current-page="currentPage" :per-page="perPage">
      <template slot="options" slot-scope="row">
        <b-button variant="secondary" size="sm" @click="goToEdit(row.item.id)" class="mr-2">
          <i title="Edit" class="cui-pencil icons"></i>
        </b-button>
      </template>
      <template slot="status_id" slot-scope="row">
        <b-badge v-if="row.item.status.id === 1" variant="primary" class="float-left px-2 py-2">Opened</b-badge>
        <b-badge v-if="row.item.status.id === 2" variant="success" class="float-left px-2 py-2">Accepted</b-badge>
        <b-badge v-if="row.item.status.id === 3" variant="warning" class="float-left px-2 py-2">Waiting</b-badge>
        <b-badge v-if="row.item.status.id === 4" variant="danger" class="float-left px-2 py-2">Rejected</b-badge>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(filteredItems)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
    </nav>
  </b-card>
</template>

<script>
import { globalStore } from '@/main'

export default {
  name: 'users-table',
  props: {
    caption: {
      type: String,
      default: 'Registered Users'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      search: '',
      items: [],
      fields: [
        {key: 'id', sortable: true},
        {key: 'user.last_name', formatter: 'formatterFullName', label: "User"},
        {key: 'user.email', label: "Email"},
        {key: 'registered_products_ids', label: "Products Count", formatter: 'formatterCountProducts'},
        {key: 'status_id', sortable: true, label: "Status", formatter: 'formatterStatus'},
        {key: 'created_at', sortable: true, label: "Created"},
        "options"
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  mounted () {
    this.loadUsersData()
  },
  methods: {
    loadUsersData () {
      let cmp = this

      cmp.axios.get(globalStore.API_BASE_URL + 'api/applications-with-users',
        this.$store.getters.getAxiosConfig).then((response) => {
        let responseData = response.data
        if (responseData.code === 200) {
          cmp.items = responseData.data
        } else {
          alert('There was problem with fetch data from server.')
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    fetchExportToCsv () {
      let cmp = this

      return cmp.axios.get(globalStore.API_BASE_URL + 'api/applications-with-users-and-products',
        this.$store.getters.getAxiosConfig).then((response) => {
        let responseData = response.data
        if (responseData.code === 200) {
          return this.flattenedItems(responseData.data);
        } else {
          alert('There was problem with fetch data from server.')
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    flattenedItems (items) {

      let cmp = this
      let newItems = [];

      //let items = JSON.parse(JSON.stringify(cmp.filteredItems))
      items.forEach((item) => {
        let flattenedItem = item

        delete flattenedItem.status_id
        flattenedItem.status = item.status.status

        delete flattenedItem.user_id
        flattenedItem.user_first_name = item.user.first_name
        flattenedItem.user_last_name = item.user.last_name
        flattenedItem.user_email = item.user.email
        flattenedItem.user_phone = item.user.phone
        flattenedItem.user_street = item.user.street
        flattenedItem.user_house_number = item.user.house_number
        flattenedItem.user_flat_number = item.user.flat_number
        flattenedItem.user_city = item.user.city
        flattenedItem.user_zip_code = item.user.zip_code
        flattenedItem.administrative_region_1 = item.user.administrative_region_1
        flattenedItem.administrative_region_2 = item.user.administrative_region_2
        flattenedItem.user_terms_agreement = item.user.terms_agreement
        flattenedItem.user_terms_agreement_text = item.user.terms_agreement_text
        flattenedItem.user_electronic_agreement = item.user.electronic_agreement
        flattenedItem.user_electronic_agreement_text = item.user.electronic_agreement_text
        flattenedItem.user_marketing_agreement = item.user.marketing_agreement
        flattenedItem.user_marketing_agreement_text = item.user.marketing_agreement_text
        delete flattenedItem.user
        delete flattenedItem.registered_products_ids

        flattenedItem.products = flattenedItem.registered_products.length
        flattenedItem.registered_products.forEach((product) => {
          let itemWithProduct = Object.assign({}, flattenedItem);
          itemWithProduct.product_id = product.id
          itemWithProduct.product_name = product.name
          itemWithProduct.product_serial_number = product.serial_number
          itemWithProduct.product_purchase_date = product.purchase_date
          itemWithProduct.product_shop_type = product.shop_type
          itemWithProduct.product_shop_www = product.shop_www
          itemWithProduct.product_shop_name = product.shop_name
          itemWithProduct.product_shop_address = product.shop_address
          itemWithProduct.product_shop_city = product.shop_city
          itemWithProduct.product_shop_zip_code = product.shop_zip_code
          //itemWithProduct.product_document_purchase_name = product.document_purchase_name
          //itemWithProduct.product_document_warranty_name = product.document_warranty_name

          delete itemWithProduct.registered_products

          newItems.push(itemWithProduct)
        });


      })
      return newItems
    },
    getRowCount (items) {
      return items.length
    },
    formatterFullName (value, key, item) {
      return `${item.user.last_name} ${item.user.first_name}`
    },
    formatterFirstLetterUC (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatterStatus (value, key, item) {
      return `${item.status.status}`
    },
    formatterCountProducts (value) {
        return JSON.parse(value).length
    },
    goToEdit (id) {
      this.$router.push('/applications/' + id)
    }
  },
  computed: {
    filteredItems () {
      let cmp = this
      return this.items.filter((item) => {
        if (
          item.user.last_name.toLowerCase().indexOf(cmp.search.toLowerCase()) > -1 ||
          item.user.first_name.toLowerCase().indexOf(cmp.search.toLowerCase()) > -1 ||
          item.user.email.toLowerCase().indexOf(cmp.search.toLowerCase()) > -1
        ) {
          return true
        }
        return false
      })
    },

  }
}
</script>
